// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_eg-3";
export var flatBottomCorners = "_eg-5";
export var productImage = "_eg-0";
export var quantityContainer = "_eg-2";
export var quantityHeader = "_eg-6";
export var tooltip = "_eg-1";
export var wrapAndEllipsesOverflow = "_eg-4";